__turbopack_context__.v({
  "credit": "_8c82Fa_credit",
  "learn-rag": "_8c82Fa_learn-rag",
  "pista": "_8c82Fa_pista",
  "q-ant": "_8c82Fa_q-ant",
  "quote": "_8c82Fa_quote",
  "quote-container": "_8c82Fa_quote-container",
});
